import { Job, JobStatus } from '../../job-summary/Interfaces';
import { CustomerWithJobs } from './customerListTypes';

export const STATUS_CONFIG: Record<
  JobStatus,
  {
    color: string;
    cardClass: string;
    textClass: string;
    btnClass: string;
    listBtnClass: string;
    listBtnBg: string;
  }
> = {
  Active: {
    color: '#dc3545',
    cardClass: 'bg-light-danger',
    textClass: 'text-danger',
    btnClass: 'btn-danger',
    listBtnClass: 'btn-light-danger border-danger',
    listBtnBg: 'rgba(220, 53, 69, 0.2)',
  },
  Open: {
    color: '#0095E8',
    cardClass: 'bg-light-primary',
    textClass: 'text-primary',
    btnClass: 'btn-light-primary',
    listBtnClass: 'btn-light-primary border-primary',
    listBtnBg: 'rgba(0, 149, 232, 0.2)',
  },
  Overdue: {
    color: '#fd7e14',
    cardClass: 'bg-light-warning',
    textClass: 'text-warning',
    btnClass: 'btn-light-warning',
    listBtnClass: 'btn-light-warning border-warning',
    listBtnBg: 'rgba(253, 126, 20, 0.2)',
  },
  Pending: {
    color: '#ffc107',
    cardClass: 'bg-light-warning',
    textClass: 'text-warning',
    btnClass: 'btn-light-warning',
    listBtnClass: 'btn-light-warning border-warning',
    listBtnBg: 'rgba(255, 193, 7, 0.2)',
  },
  'Awaiting Client Response': {
    color: '#ffc107',
    cardClass: 'bg-light-warning',
    textClass: 'text-warning',
    btnClass: 'btn-light-warning',
    listBtnClass: 'btn-light-warning border-warning',
    listBtnBg: 'rgba(255, 193, 7, 0.2)',
  },
  Closed: {
    color: '#198754',
    cardClass: 'bg-light-success',
    textClass: 'text-success',
    btnClass: 'btn-light-success',
    listBtnClass: 'btn-light-success border-success',
    listBtnBg: 'rgba(25, 135, 84, 0.2)',
  },
  Cancelled: {
    color: '#6c757d',
    cardClass: 'bg-light-secondary',
    textClass: 'text-secondary',
    btnClass: 'btn-light-secondary',
    listBtnClass: 'btn-light-secondary border-secondary',
    listBtnBg: 'rgba(108, 117, 125, 0.2)',
  },
  Archived: {
    color: '#6c757d',
    cardClass: 'bg-light-secondary',
    textClass: 'text-secondary',
    btnClass: 'btn-light-secondary',
    listBtnClass: 'btn-light-secondary border-secondary',
    listBtnBg: 'rgba(108, 117, 125, 0.2)',
  },
};

const PRIORITY_ORDER: JobStatus[] = [
  'Active',
  'Overdue',
  'Open',
  'Pending',
  'Awaiting Client Response',
  'Closed',
  'Cancelled',
  'Archived',
];

export function getPriorityStatus(jobs: Job[]): JobStatus {
  for (const status of PRIORITY_ORDER) {
    if (jobs.some((job) => job.status === status)) return status;
  }
  return 'Archived';
}

export function getCardStyle(customer: CustomerWithJobs): string {
  return STATUS_CONFIG[getPriorityStatus(customer.activeJobs)].cardClass;
}

export function getTextStyle(customer: CustomerWithJobs): string {
  return STATUS_CONFIG[getPriorityStatus(customer.activeJobs)].textClass;
}

export function getBadgeColor(customer: CustomerWithJobs): string {
  return STATUS_CONFIG[getPriorityStatus(customer.activeJobs)].color;
}

const DEFAULT_STATUS_CONFIG = {
  color: '#ffc107',
  btnClass: 'btn-light-warning',
  listBtnClass: 'btn-light-warning border-warning',
  listBtnBg: 'rgba(255, 193, 7, 0.2)',
};

export function getJobBadgeColor(job: Job, isJobActive?: boolean): string {
  if (isJobActive) return STATUS_CONFIG.Active.color;
  const config = STATUS_CONFIG[job.status as JobStatus] ?? DEFAULT_STATUS_CONFIG;
  return config.color;
}

export function getJobButtonClass(job: Job, isJobActive?: boolean): string {
  if (isJobActive) return STATUS_CONFIG.Active.btnClass;
  const config = STATUS_CONFIG[job.status as JobStatus] ?? DEFAULT_STATUS_CONFIG;
  return config.btnClass;
}

export function getJobListButtonClass(job: Job): string {
  const config = STATUS_CONFIG[job.status as JobStatus] ?? DEFAULT_STATUS_CONFIG;
  return config.listBtnClass;
}

export function getJobListButtonBgColor(job: Job): string {
  const config = STATUS_CONFIG[job.status as JobStatus] ?? DEFAULT_STATUS_CONFIG;
  return config.listBtnBg;
}
